import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/adm/diretorias${queryUrl}`)
  },
  insert(data) {
    return axios.post('/adm/diretorias/', data)
  },
  edit(data) {
    return axios.put(`/adm/diretorias/${data.id}`, data)
  },
  delete(id) {
    return axios.put(`/adm/diretorias/${id}`)
  },
}
